import { Button, Checkbox, TableCell, TableRow } from '@mui/material'
import { formatCurrency } from '../../../../utils/helpers'
import { Send } from '@mui/icons-material';
import InvoiceCreatePopUpModel from './InvoiceCreatePopUpModel';
import { useState } from 'react';
import orderService from '../../../../services/orderService';

const Order = ({ itemToRender: order, handleViewMoreClick, handleSelect, isSelected }) => {
  const getOrderStatusText = (status) => {
    switch (status) {
      case 0:
        return "Yeni";
      case 1:
        return "Hazırlanıyor";
      case 2:
        return "Kargolanan";
      case 3:
        return "Teslim Edilen";
      case 4:
        return "İade & Değişim Talebi";
      case 5:
        return "İptal edilen";
      case 6:
        return "Teslim Edilmeyen";
      case 7:
        return "Faturalandırılmış";
      case 99:
        return "Tümü";
      default:
        return "Bilinmeyen Durum";
    }
  };
  const [openInvoiceModal, setOpenInvoiceModal] = useState(false);

  const buttonHoverStyle = {
    backgroundColor: 'rgb(99, 102, 241)',
    color: 'white',
    transform: 'translateY(-1px)',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  };

  const buttonBaseStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px',
    padding: '6px',
    borderRadius: '6px',
    border: '1px solid',
    borderColor: 'rgb(99, 102, 241)',
    backgroundColor: 'white',
    color: 'rgb(99, 102, 241)',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    margin: '0 2px'
  };

  return (
    <TableRow
      sx={{
        '&:hover': {
          backgroundColor: '#F7F9FC',
          transition: 'all 0.2s ease',
          boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
        },
        '& td': {
          padding: '16px 12px',
          borderBottom: '1px solid #edf2f7'
        }
      }}
    >
      <TableCell padding="checkbox">
        <Checkbox
          checked={isSelected}
          onChange={handleSelect}
          sx={{
            '&.Mui-checked': { color: '#1F1B45' }
          }}
          disabled={order?.invoiced}
        />
      </TableCell>
      <TableCell>
        <div className="flex items-center">
          <img
            src={order.marketPlace?.iconLink || order.ecommercePlace?.iconLink}
            alt="Marketplace Icon"
            referrerPolicy="no-referrer"
            style={{
              width: 40,
              height: 40,
              borderRadius: '8px',
              objectFit: 'cover',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}
          />
        </div>
      </TableCell>
      <TableCell>
        {getOrderStatusText(order.status)}
      </TableCell>
      <TableCell>
        <Button
          variant="outlined"
          onClick={() => handleViewMoreClick(order)}
          sx={{
            borderRadius: '8px',
            textTransform: 'none',
            borderColor: '#1F1B45',
            color: '#1F1B45',
            minWidth: '100px',
            '&:hover': {
              borderColor: '#2C285A',
              backgroundColor: 'rgba(31, 27, 69, 0.04)'
            }
          }}
        >
          Ayrıntılar
        </Button>
      </TableCell>
      <TableCell sx={{ fontWeight: 500, color: '#1F1B45' }}>{order.orderNumber}</TableCell>
      <TableCell>
        {new Date(order.orderDate).toLocaleString('tr-TR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        })}
      </TableCell>
      <TableCell sx={{ fontWeight: 500 }}>{`${order.customerFirstName} ${order.customerLastName}`}</TableCell>
      <TableCell>{order.cargoProviderName}</TableCell>
      <TableCell sx={{ fontWeight: 500, color: '#1F1B45' }}>
        {formatCurrency(order.currencyCode, order.totalPrice)}
      </TableCell>
      <TableCell>
        <button
          className={`hover:bg-indigo-600 hover:text-white ${order.invoiced ? "opacity-50 cursor-not-allowed" : ""}`}
          style={order.invoiced ? { ...buttonBaseStyle, opacity: 0.5, cursor: "not-allowed" } : buttonBaseStyle}
          onMouseOver={e => !order.invoiced && Object.assign(e.currentTarget.style, buttonHoverStyle)}
          onMouseOut={e => !order.invoiced && Object.assign(e.currentTarget.style, buttonBaseStyle)}
          onClick={() => !order.invoiced && setOpenInvoiceModal(true)}
          title="Fatura Listesine Ekle"
          disabled={order.invoiced}
        >
          <Send fontSize="small" />
        </button>
      </TableCell>

      <InvoiceCreatePopUpModel
        open={openInvoiceModal}
        handleClose={() => setOpenInvoiceModal(false)}
        order={order}
        userId={order.userId}
      />
    </TableRow>
  )
}

export default Order